import { convertLocaltoUTCFormat } from "../../../services/DateFormatUtility";

export const FEU_COMPLIANCE_BALANCE_REPORTS_COLUMNS = [

    {
        header: "WCN",
        enableHiding: false,
        accessorKey: "wcnNumber",
        maxSize: 80,
        enableSorting: false,
    },
    {
        header: "WCN Company Name",
        accessorKey: "wcnCompanyName",
        minSize: 200,
        enableSorting: false,
    },
    {
        header: "Company Name",
        accessorKey: "companyName",
        minSize: 200,
        enableSorting: false,
    },
    {
        header: "Company IMO Number",
        accessorKey: "companyImoNumber",
        enableSorting: false,
    },
    {
        header: "FEUCBVR ID",
        accessorKey: "feuCbvrId",
        enableSorting: false,
    },
    {
        header: "Modified Date",
        accessorKey: "modifiedDate",
        accessorFn: (row) => (
            <span>{convertLocaltoUTCFormat(new Date(row.modifiedDate))}</span>
        ),
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnActions: false,
    },

]